import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../login/authentication/authentication.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class BasicInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    /**
     *
     *
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof BasicInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(request.url.includes(environment.apiVTC) || request.url.includes(environment.apiVTC)) {
            var cred = btoa("cross:platform");
            request = request.clone({
                setHeaders: {
                    Authorization: `Basic ${cred}`
                }
            });
        }

        return next.handle(request);
    }
}
